module.exports = __webpack_public_path__ + "static/media/Group 2883.4b69ae6d.svg";